<template>
	<ui-tag-manager
		service="channels"
		title="Canal"
		delete-modal-title="Deseja realmente excluir o(s) canal(is)?"
	/>
</template>

<script>
	import {
		uiTagManager
	} from '@/components/ui-facilita/tags'

	export default {
		components: {
			uiTagManager
		},

		created() {}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
